/**
 * Anti-bot webhook configuration.
 *
 * These values are read from Vite environment variables. Update them in your
 * `.env` file (or the Bolt hosting dashboard) — no code changes needed.
 *
 * NOTE: Vite embeds env vars prefixed with VITE_ into the client bundle, so
 * these values are visible in the browser. This is acceptable for a low-stakes
 * anti-spam webhook secret, but do NOT reuse this secret for anything
 * sensitive.
 */

export const ANTIBOT_CONFIG = {
  generateUrl: import.meta.env.VITE_N8N_CAPTCHA_GENERATE_URL || '',
  verifyUrl: import.meta.env.VITE_N8N_SIGNUP_VERIFY_URL || '',
  webhookSecret: import.meta.env.VITE_N8N_WEBHOOK_SECRET || '',
};

export const ANTIBOT_HEADERS: HeadersInit = {
  'Content-Type': 'application/json',
  'x-webhook-secret': ANTIBOT_CONFIG.webhookSecret,
};
